import { call, put, takeLatest } from "redux-saga/effects";
import { authorizedRequest, downloadXLSFile } from "utils/api";
import _ from "lodash";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  requestSaga,
  fillDictionary
} from "../../utils/helpers";

export const initialState = {
  capResult: {
    notional: null,
    capCost: null,
    capPrices: []
  }
};

export const RESET_TEST_DATA = "RESET_TEST_DATA";

// CALCULATE_CAP
export const CALCULATE_CAP = generateDefaultActions("CALCULATE_CAP");
export const calculateCap = payload => makePayload(CALCULATE_CAP.value, payload);
function* calculateCapSaga(payload) {
  const url = "/calc/calculateCap";
  yield requestSaga(CALCULATE_CAP, url, "POST", payload);
}

export function* capPricerSaga() {
  yield takeLatest(CALCULATE_CAP.value, calculateCapSaga);
}

export default function capPricerReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CALCULATE_CAP.success:
      ToastSuccess("Calculation Complete");

      return defaultReturn(state, payload, "capResult");
    case CALCULATE_CAP.failure:
      ToastError(`Error: Please check your calculation selections (${_.get(payload.response, "data.message", "Error: please get LoanBoss Administrator assistance.")})`);

      return state;

    case RESET_TEST_DATA:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
}
